import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <h1><FormattedMessage id="message.notFound" /></h1>;
